import { VBHover } from './hover';
import { pluginFactory } from '../../utils/plugins';
var VBHoverPlugin = /*#__PURE__*/pluginFactory({
  directives: {
    VBHover: VBHover
  }
});
export { VBHoverPlugin, VBHover };


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/bootstrap-vue@2.23.1_jquery@3.7.1_vue@2.6.14/~/bootstrap-vue/esm/directives/hover/index.js
// module id = nx7w
// module chunks = 5